export enum ORGANIZATION_STATUSES {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}
